<template>
<div v-if="false" class="cambook-footer">
  <div class="footer-content">Copyright 2006-2024 Xi'an Jiaotong-Liverpool University 苏ICP备07016150号-1 苏公网安备32059002001410号</div>
</div>
</template>

<script>
export default {
  name: 'LayoutFooter',
}
</script>

<style scoped lang="scss">
@import "@/assets/styles/mixin";
.cambook-footer{
  width: 100%;
  height: 34px;
  line-height: 34px;
  background-color: #F8F8F8;
  color: var(--cam-color-black);
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  .footer-content{
    @include baseWidth();
    text-align: center;
  }
}
</style>
